module.exports = __webpack_public_path__ + "img/img_consulta_agora.3d44d876.svg";